import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Slide, Text } from '@chakra-ui/react';
import { Area } from '@whitbread-eos/api';
import { BurgerMenu, ChevronRight, Icon } from '@whitbread-eos/atoms';
import { formatDataTestId, formatTextWithSpace } from '@whitbread-eos/utils';
import { useState } from 'react';
import HeaderSideNav from '../../HeaderLeisure/NavigationMenuMobile/HeaderSideNav';
import LanguageSelectorSideNav from '../../HeaderLeisure/NavigationMenuMobile/LanguageSideNav';
import NavigationItem from '../../HeaderLeisure/NavigationMenuMobile/NavigationItem';
import MobileNavItem from './MobileNavItem';
import MobileSideNav from './MobileSideNav';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function BBNavigationMenuMobile(_ref) {
  var navigationLabels = _ref.navigationLabels,
    languageMenuLabels = _ref.languageMenuLabels,
    language = _ref.language,
    tickIcon = _ref.tickIcon,
    isLogoutButton = _ref.isLogoutButton,
    genericLabels = _ref.genericLabels;
  var baseDataTestId = 'BusinessNavMobile';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var _useState3 = useState('default'),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSideNav = _useState4[0],
    setSelectedSideNav = _useState4[1];
  var navTitleLabels = navigationLabels.map(navigationLabel => navigationLabel.navTitle);
  var indexOfSelectedSideNav = navTitleLabels.indexOf(selectedSideNav);
  var toggleSideNav = sideNav => {
    setSelectedSideNav(sideNav);
  };
  return _jsxs(Flex, {
    flexDir: "column",
    "data-testid": baseDataTestId,
    children: [_jsxs(Flex, _objectSpread(_objectSpread({}, burgerMenuContainerStyle), {}, {
      sx: {
        '@media print': {
          marginLeft: 'auto'
        }
      },
      "data-testid": formatDataTestId(baseDataTestId, 'toggleButton'),
      onClick: () => {
        setIsModalVisible(true);
      },
      children: [_jsx(Icon, {
        _hover: {
          cursor: 'pointer'
        },
        svg: _jsx(BurgerMenu, {
          "data-testid": "burgerMenu"
        })
      }), _jsx(Text, _objectSpread(_objectSpread({}, burgerMenuTextStyle), {}, {
        children: genericLabels.mobileMenuButton
      }))]
    })), _jsxs(Modal, {
      isOpen: isModalVisible,
      onClose: () => {
        setIsModalVisible(false);
      },
      size: "full",
      children: [_jsx(ModalOverlay, {
        zIndex: "var(--chakra-zIndices-banner)",
        "data-testid": "modalOverlay"
      }), _jsx(Slide, {
        direction: "left",
        in: isModalVisible,
        style: {
          zIndex: 'var(--chakra-zIndices-overlay)'
        },
        children: _jsx(ModalContent, _objectSpread(_objectSpread({}, modalContentStyle), {}, {
          "data-testid": "modalSideBar",
          children: renderSideNav(selectedSideNav)
        }))
      })]
    })]
  });
  function renderSideNav(selectedSideNav) {
    switch (selectedSideNav) {
      case 'languageSelector':
        {
          var labels = {
            language: genericLabels.language
          };
          return _jsx(LanguageSelectorSideNav, {
            currentLanguage: language,
            languagesList: languageMenuLabels,
            onClickHeaderTitle: () => toggleSideNav('default'),
            tickIcon: tickIcon,
            area: Area.BB,
            labels: labels
          });
        }
      case navTitleLabels[indexOfSelectedSideNav]:
        return _jsx(MobileSideNav, {
          title: navigationLabels[indexOfSelectedSideNav].navTitle,
          labels: navigationLabels[indexOfSelectedSideNav].subNav,
          onClickHeaderTitle: () => toggleSideNav('default'),
          baseTestId: formatTextWithSpace(navigationLabels[indexOfSelectedSideNav].navTitle)
        });
      default:
        return _jsxs(_Fragment, {
          children: [_jsx(HeaderSideNav, {}), _jsx(ModalBody, {
            p: "0",
            "data-testid": "defaultSideNav",
            children: _jsxs(Flex, {
              flexDir: "column",
              children: [_jsx(Box, {
                "data-testid": formatDataTestId(baseDataTestId, 'TriggerLanguageSideNav'),
                onClick: () => toggleSideNav('languageSelector'),
                children: _jsx(Box, _objectSpread(_objectSpread({}, customContainerItemStyle), {}, {
                  _hover: {
                    color: 'primary'
                  },
                  children: _jsx(NavigationItem, {
                    title: _jsxs(_Fragment, {
                      children: [renderFlag(language), _jsx(Box, {
                        pl: "sm",
                        children: _jsx(Text, {
                          color: "darkGrey1",
                          children: findLanguageName(language)
                        })
                      })]
                    }),
                    icon: _jsx(Box, {
                      pt: "0.37rem",
                      pl: "sm",
                      children: _jsx(Icon, {
                        svg: _jsx(ChevronRight, {})
                      })
                    })
                  })
                }))
              }), navTitleLabels.map(navTitleLabel => {
                return _jsx(MobileNavItem, {
                  navTitleLabel: navTitleLabel,
                  navigationLabels: navigationLabels,
                  toggleSideNav: toggleSideNav,
                  baseDataTestId: baseDataTestId,
                  isLogoutButton: isLogoutButton
                }, navTitleLabel);
              })]
            })
          })]
        });
    }
  }
  function findLanguageName(language) {
    var country = languageMenuLabels.find(languageObject => languageObject.locale == language);
    if (country) {
      return country.languageName;
    }
  }
  function renderFlag(language) {
    var country = languageMenuLabels.find(languageObject => languageObject.locale == language);
    if (country) {
      return country.icon;
    }
  }
}
var containerItemStyle = {
  p: 'md',
  pl: 0,
  borderBottom: 'var(--chakra-space-px) solid var(--chakra-colors-lightGrey2)',
  w: {
    mobile: '16.87rem',
    xs: '20.31rem',
    sm: '20.75rem',
    md: '21.69rem'
  },
  ml: 'auto',
  _hover: {
    cursor: 'pointer'
  }
};
var burgerMenuContainerStyle = {
  pt: '0.5rem',
  flexDir: 'column',
  justifyContent: 'center',
  alignItems: 'center'
};
var burgerMenuTextStyle = {
  pt: '0.375rem',
  fontSize: 'sm',
  lineHeight: '2',
  fontWeight: 'normal'
};
var modalContentStyle = {
  borderRadius: 0,
  position: 'absolute',
  zIndex: 'var(--chakra-zIndices-overlay)',
  left: 0,
  display: {
    lg: 'none'
  },
  w: {
    mobile: '72',
    xs: '21.44rem',
    sm: '21.875rem',
    md: '23.25rem'
  }
};
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  flexDirection: 'column',
  ml: '0',
  pl: 'md',
  w: '100%'
});